exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags ul { display: block; }\n.tags ul li { \n    display: inline-block;\n    border-radius: 3px;\n    background: #efefef;\n    padding: 3px 5px;\n    font-size: 12px;\n    margin-right: 3px;\n    font-weight: 600;\n    font-style: italic;\n}\n#public-url .modal-dialog { width: 65% }\n#public-url .search, #public-url .search .input-field { margin-top: 0; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/mail-public-url/mail-public-url.component.css
// module id = ../../../../../src/app/mnt-invoices/mail-public-url/mail-public-url.component.css
// module chunks = common